exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip {\n    position: relative;\n    display: inline-block;\n    /*border-bottom: 1px dotted black;*/\n}\n\n.tooltip .tooltiptext {\n    visibility: hidden;\n    width: 140px;\n    background-color: #1175B2;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0px;\n    position: absolute;\n    z-index: 1;\n    margin-left: -50px;\n    opacity: 0;\n    transition: opacity 1s;\n}\n\n.tooltip:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1;\n}\n", ""]);

// exports
